// @ts-check
/** @type {import('js-cookie')} */

/** @type {Window & globalThis & { registerTranslateString?: { mail_magazine_campaign: { text_1: string, text_2_html: string }}}} */ 
const w = window;

/** @type {HTMLElement | null} */
const cfBlock = document.querySelector(".cf-form-block");

if (cfBlock) {
  /** @type {undefined | number} */
  let intervalID_1 = undefined;

  intervalID_1 = setInterval(() => {
    /** @type {HTMLElement | null} */
    const firstFieldContainer = cfBlock.querySelector(".cf-field-container");
    console.log(firstFieldContainer);

    if (firstFieldContainer) {
      clearInterval(intervalID_1);
      insertCampaignHTML(firstFieldContainer);
    }
  }, 50);

  /** @type {undefined | number} */
  let intervalID_2 = undefined;

  intervalID_2 = setInterval(() => {
    /** @type {HTMLElement | null} */
    const cfFieldsContainer = cfBlock.querySelector(".cf-fields-container");

    if (cfFieldsContainer) {
      clearInterval(intervalID_2);
      insertConsentCheckBlock(cfFieldsContainer);

      /** @type {HTMLButtonElement | null} */
      const cfSubmitForm = cfBlock.querySelector(".cf-submit-form");
      /** @type {HTMLInputElement | null} */
      const consentCheck = document.querySelector("#consent-check");
      if (cfSubmitForm && consentCheck) {
        cfSubmitForm.disabled = true;
        cfSubmitForm.setAttribute("aria-disabled", "true");

        consentCheck.addEventListener("change",
          /**
           * @param {Event} event 
           */
          (event) => {
          const target = /** @type {HTMLInputElement} */ (event.currentTarget);
          if (target.checked) {
            cfSubmitForm.disabled = false;
            cfSubmitForm.setAttribute("aria-disabled", "false");
          } else {
            cfSubmitForm.disabled = true;
            cfSubmitForm.setAttribute("aria-disabled", "true");
          }
        });

        /* Cookie判定は削除済み — 常に同意チェックを表示 */
      }

    }
  }, 50);
}

/**
 * 対象の要素の後にキャンペーンを挿入する
 * @param {HTMLElement} target 
 */
function insertCampaignHTML(target) {
  const html = `<div class="register-mail-magazine-campaign">
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="register-mail-magazine-campaign__icon">
    <circle cx="20" cy="20" r="20" fill="#FF94BE"/>
    <path d="M31.2985 9.1743L7.32968 17.0988L12.0064 31.4938L31.2985 9.1743Z" fill="#D2F0FC"/>
    <path d="M12.0041 31.4938L14.3584 26.0129L18.5928 28.1185L12.0041 31.4938Z" fill="#99CAFA"/>
    <path d="M4.49 18.0213L8.7358 21.4611L31.1487 9.16068L14.3538 26.0126L23.2219 33.1967C23.9885 33.817 25.152 33.4413 25.3924 32.4963L31.2394 9.42972C31.3052 9.17402 31.0671 8.945 30.8063 9.0117L5.00485 15.7222C3.9434 15.9979 3.64401 17.3365 4.49 18.0235V18.0213Z" fill="white"/>
  </svg>

  <div>
    <p class="register-mail-magazine-campaign__text">${w?.registerTranslateString?.mail_magazine_campaign.text_1}</p>
    <p class="register-mail-magazine-campaign__text2">${w?.registerTranslateString?.mail_magazine_campaign.text_2_html}</p>
  </div>
</div>`;

  target.insertAdjacentHTML("afterend", html);
}

/**
 * 対象の要素の前に同意チェックを挿入する
 * @param {HTMLElement} target 
 */
/**
   * @typedef { Window & {
*   termsUpdate?: string;
*   consentCheckTranslateString?: {
*     lead_text: string;
*     terms_label: string;
*     privacy_policy_label: string;
*     checkbox_label: string;
*   }
* }} ExtendedWindow
*/
/** @type {ExtendedWindow} w */
const extendedWindow = window;
function insertConsentCheckBlock(target) {
  const html = `<div class="consent-block" data-update="${extendedWindow?.termsUpdate}">
  <p class="consent-block__text">${extendedWindow.consentCheckTranslateString?.lead_text}</p>
  <div class="consent-block__links">
    <a href="/policies/terms-of-service" target="_blank">${extendedWindow.consentCheckTranslateString?.terms_label}</a>
    <a href="https://vivion.jp/privacy_protection/" target="_blank">${extendedWindow.consentCheckTranslateString?.privacy_policy_label}</a>
  </div>
  <div class="consent-block__units">
    <label class="checkbox">
      <input type="checkbox" id="consent-check" class="checkbox__input">
      <span class="checkbox__mark">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.07578 12.2984L2.17578 8.39842C1.94141 8.16404 1.94141 7.78436 2.17578 7.54998L3.02422 6.70154C3.25859 6.46716 3.63828 6.46716 3.87266 6.70154L6.50001 9.32888L12.1273 3.70154C12.3617 3.46716 12.7414 3.46716 12.9758 3.70154L13.8242 4.54998C14.0586 4.78435 14.0586 5.16404 13.8242 5.39842L6.92423 12.2984C6.68985 12.5328 6.31016 12.5328 6.07578 12.2984Z" fill="white"/>
        </svg>
      </span>
      <span class="checkbox__text">${extendedWindow.consentCheckTranslateString?.checkbox_label}</span>
    </label>
  </div>
</div>`;

  target.insertAdjacentHTML("beforeend", html);
}